import React, { useContext } from 'react';
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LeaderboardIframeWidget from '../../widgets/LeaderboardIframeWidget';
import ResultsWidget from '../../widgets/ResultsWidget';
import { environmentVariables } from '../../utils/helpers/environmentVariables';
import { CurrentRaceEventContext } from '../../context/currentRaceEvent.context';
import { LoginContext } from '../../context/login.context';
import './Leaderboard.scss';

const Leaderboard: React.FC = () => {
    const { eventId } = useParams<{ eventId: string }>(); // This is now the regattaId
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { allRaceEvents } = useContext(CurrentRaceEventContext);
    const { isInternalUser } = useContext(LoginContext);
    const baseUrl = environmentVariables.sailgpResultsUrl();

    const eventName = searchParams.get('eventName')
        ? decodeURIComponent(searchParams.get('eventName')!)
        : location.state?.eventName;

    // Find the event to get its season ID
    const event = allRaceEvents?.find(e => e.regattaId === eventId);
    const seasonId = event?.eventSeason;

    if (!eventId) {
        return (
            <div className="leaderboard-container">
                <div className="leaderboard-error">
                    <h2>Event not found</h2>
                    <Button
                        variant="contained"
                        onClick={() => navigate('/schedule')}
                        startIcon={<ArrowBackIcon />}
                    >
                        Back to Schedule
                    </Button>
                </div>
            </div>
        );
    }

    const iframeUrl = baseUrl && seasonId
        ? `${baseUrl}?widget=true&contentonly=true&tab=event&regattaId=${eventId}&seasonId=${seasonId}&singleEvent=true`
        : '';

    return (
        <div className={`leaderboard-container ${!isInternalUser && iframeUrl ? 'with-iframe' : ''}`}>
            <div className="leaderboard-header">
                <Button
                    className="leaderboard-back-button"
                    variant="outlined"
                    onClick={() => navigate(-1)}
                    startIcon={<ArrowBackIcon />}
                >
                    Back
                </Button>
                <h1 className="leaderboard-title">
                    {eventName ? `${eventName} - Race Results` : 'Race Results'}
                </h1>
            </div>
            <div className="leaderboard-content">
                {isInternalUser ? (
                    <ResultsWidget />
                ) : iframeUrl ? (
                    <LeaderboardIframeWidget
                        src={iframeUrl}
                        title={eventName ? `${eventName} - Race Results` : 'Race Results'}
                    />
                ) : (
                    <div style={{ color: '#999', padding: '20px' }}>
                        Results URL not configured
                    </div>
                )}
            </div>
        </div>
    );
};

export default Leaderboard;